module.exports = __webpack_public_path__ + "static/media/relove-icon.1f5beace.png";